import store from "@/state/store.js";
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/index.js";
import axios from "axios";
import VueI18n from "vue-i18n";
import i18n from "./i18n";
import VueSimpleAlert from "vue-simple-alert";
import Swal from "sweetalert2";
import DOMPurify from "dompurify";
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

document.title = "Διαχείριση Αιτήσεων ΣΣΕ";

// Custom directive: v-safe-html sanitises HTML via DOMPurify before injecting,
// preventing stored-XSS through rich-text fields (about, person.bio, etc.).
const setSanitized = (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value == null ? '' : String(binding.value));
};
Vue.directive('safe-html', {
  bind: setSanitized,
  update: setSanitized,
});


// Same-origin: nginx (see frontend/nginx.conf) proxies backend paths
// (/api, /auth, /user, /invitation, /submission, /sendEmail,
//  /generate-reset-token, /reset-password) to the backend container.
// Leaving baseURL empty makes axios issue same-origin requests, which
// works for both the production deployment at https://apply.sse.gr and
// local Docker Compose at http://localhost:9091.
axios.defaults.baseURL = "";

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      Swal.fire({
        title: "Ανακατεύθυνση...",
        html: "Η συνεδρία σας έχει λήξει, παρακαλώ συνδεθείτε ξανά",
        timer: 5000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      }).then(() => {
        store.dispatch('user/destroyToken').finally(() => {
          router.push("login");
        });
      });
      return Promise.reject('Unauthorized');
    }
    return Promise.reject(error);
  }
);

Vue.use(VueI18n);
Vue.use(VueSimpleAlert);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
